<template>
  <div>
    <table class="table table-striped table-sm">
      <thead>
        <tr>
          <th>Query Position</th>
          <th>Target Position</th>
          <th>Description</th>
          <th>Score</th>
          <th>% Identity</th>
          <th>e-value</th>
        </tr>
      </thead>
      <template v-for="h in hits">
        <thead :key="'head_' + h.target.dbxref">
          <tr class="category">
            <th colspan="6">
              <a :href="dbxrefs[h.target.dbxref].link">{{ h.target.dbxref }}</a>
            </th>
          </tr>
        </thead>
        <tbody :key="'body_' + h.target.dbxref">
          <tr>
            <td>{{ h.query.start }} - {{ h.query.end }}</td>
            <td>{{ h.target.start }} - {{ h.target.end }}</td>
            <td>{{ dbxrefs[h.target.dbxref].description }}</td>
            <td>{{ "score" in h.target ? h.target.score.toFixed(2) : "" }}</td>
            <td>
              {{
                "percent_identity" in h.target
                  ? h.target.percent_identity.toFixed(2)
                  : ""
              }}
            </td>
            <td>{{ "evalue" in h.target ? h.target.evalue : "" }}</td>
          </tr>
        </tbody>
      </template>
    </table>
  </div>
</template>
<script>
export default {
  name: "HomologyTable",
  props: {
    hits: {
      type: Array,
      default: function() {
        return [];
      }
    },
    dbxrefs: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  methods: {
    hitValue: function(obj, key, def) {
      if (def == undefined) {
        def = "";
      }
      if (key in obj) {
        // checks if key exists and returns it
        return obj[key];
      } else {
        // otherwise returns empty string
        return def;
      }
    }
  }
};
</script>
<style scoped></style>
